import React, { useState } from 'react';
import { usePlausible } from '../hooks/usePlausible';

const initialState = {
  type: 'bug',
  message: '',
  image: null,
  email: '',
};

const FeedbackWidget = ({ onSend }) => {
  const plausible = usePlausible();
  
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(initialState);
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'image') {
      setForm(f => ({ ...f, image: files[0] }));
    } else {
      setForm(f => ({ ...f, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError('');
    setSuccess(false);
    try {
      await onSend(form);
      
      // Track successful feedback submission
      plausible.trackFeedbackSent(form.type);
      
      setSuccess(true);
      setForm(initialState);
    } catch (err) {
      setError('Erro ao enviar. Tente novamente.');
    }
    setSending(false);
  };

  return (
    <>
      {/* Botão flutuante */}
      <button
        className="fixed z-50 bottom-6 right-6 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg p-4 flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
        onClick={() => setOpen(true)}
        aria-label="Enviar feedback"
        type="button"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M7 8h10M7 12h4m1 8a9 9 0 100-18 9 9 0 000 18z" /></svg>
        <span className="hidden sm:inline font-semibold">Feedback</span>
      </button>
      {/* Modal */}
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 relative animate-fade-in">
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
              onClick={() => { setOpen(false); setSuccess(false); setError(''); }}
              aria-label="Fechar"
              type="button"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
            </button>
            <h2 className="text-lg font-bold text-blue-700 mb-2">Reportar bug ou sugestão de melhoria</h2>
            <form onSubmit={handleSubmit} className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tipo</label>
                <select
                  name="type"
                  value={form.type}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-2 py-1 focus:ring-blue-500 focus:border-blue-500"
                  required
                >
                  <option value="bug">Bug</option>
                  <option value="sugestao">Sugestão</option>
                  <option value="outro">Outro</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Mensagem <span className="text-red-500">*</span></label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-2 py-1 min-h-[80px] focus:ring-blue-500 focus:border-blue-500"
                  required
                  maxLength={1000}
                  placeholder="Descreva o problema ou sugestão..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Anexar arquivo (opcional)</label>
                <input
                  type="file"
                  name="image"
                  accept=".png,.jpg,.jpeg,.gif,.bmp,.webp,.csv,.xlsx,image/*,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                  onChange={handleChange}
                  className="block w-full text-sm text-gray-500"
                />
                {form.image && (
                  <div className="mt-1 text-xs text-gray-600">{form.image.name}</div>
                )}
              </div>
              {/*
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email para resposta (opcional)</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-2 py-1 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Seu email (opcional)"
                />
              </div>
              */}
              {error && <div className="text-red-600 text-sm">{error}</div>}
              {success && <div className="text-green-600 text-sm">Enviado com sucesso! Obrigado pelo feedback.</div>}
              <button
                type="submit"
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded transition-colors disabled:opacity-60"
                disabled={sending}
              >
                {sending ? 'Enviando...' : 'Enviar'}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default FeedbackWidget;
